// import axios from "axios";

// const useApiCaller = () => {
//   const access_token = localStorage.getItem("authState");
//   const { user } = JSON.parse(access_token);
//   const apiCaller = axios.create({
//     baseURL: process.env.REACT_APP_BASE_URL,
//     headers: {
//       Authorization: `${user?.access_token}`,
//       userid: user._id,
//     },
//   });

//   return apiCaller;
// };

// export default useApiCaller;

import axios from 'axios';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useCredentials from './useCredentials';
import { storeRedirectUrl } from '../utils/sessionUtils';
const useApiCaller = () => {
  const { token: access_token, userData: user, logout } = useCredentials();
  // const { user } = JSON.parse(access_token);
  const navigate = useNavigate();

  const apiCaller = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      headers: {
        Authorization: `${access_token}`,
        userid: user.employeeId,
      },
    });

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error.response?.status === 401 ||
          (error.response?.data?.message &&
            (error.response.data.message === 'Token has expired' ||
              error.response.data.message === 'Token was not recognised' ||
              error.response.data.message === 'Token not matched with userId'))
        ) {
          // Store the current URL before logout
          storeRedirectUrl();
          logout();
        }
        return Promise.reject(error);
      }
    );

    return instance;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token, user?.employeeId]);

  return apiCaller;
};

export default useApiCaller;
